import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AboutPage() {
  const navigate = useNavigate();
  const GD = "#D4AF37";
  const DG = "#064E3B";
  const BG = "#FDFBF7";
  const TXT = "rgba(0,0,0,0.82)";
  const TXT2 = "rgba(0,0,0,0.55)";

  return (
    <div style={{
      minHeight: "100vh",
      background: `linear-gradient(180deg, ${BG} 0%, #F3EFE6 50%, ${BG} 100%)`,
      fontFamily: "\"Inter\",\"Noto Serif SC\",serif",
      color: TXT,
      paddingBottom: 80,
    }}>
      {/* Hero */}
      <div style={{ textAlign: "center", padding: "80px 24px 48px" }}>
        <h1 style={{
          fontSize: "clamp(28px,5vw,44px)",
          fontWeight: 600,
          color: DG,
          marginBottom: 16,
          fontFamily: "\"Noto Serif SC\",serif",
        }}>
          关于澄光
        </h1>
        <div style={{
          width: 60, height: 2, background: GD,
          margin: "0 auto 24px", borderRadius: 1,
        }} />
        <p style={{
          fontSize: "clamp(16px,2.5vw,20px)",
          color: TXT2,
          maxWidth: 640,
          margin: "0 auto",
          lineHeight: 1.8,
        }}>
          澄光命盘 · LUMINAARC
          <br />
          引擎真算 · 不做模板拼接
        </p>
      </div>

      {/* Engine Section */}
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "0 24px" }}>
        <h2 style={{
          fontSize: 20, fontWeight: 600, color: DG,
          marginBottom: 16, marginTop: 32,
          borderLeft: `3px solid ${GD}`, paddingLeft: 12,
        }}>
          🔮 四引擎真算 — 我们的技术承诺
        </h2>
        <p style={{ fontSize: 15, lineHeight: 1.9, color: TXT2, marginBottom: 24 }}>
          市面上大多数命理产品，输入生辰、输出结果，表面看起来像模像样，背后却是 AI 在编造。<br /><br />
          <strong style={{ color: TXT }}>LUMINA 不同。</strong>我们的八字排盘、紫微斗数、六爻起卦、奇门遁甲，全部由数学引擎真实计算。AI 只负责将引擎结果翻译成你能听懂的语言——<strong>绝不做模板拼接，绝不编造排盘结果</strong>。
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 24 }}>
          {[
            { name: "八字排盘", eng: "Ba Zi", desc: "四柱精算·节气立春边界·纳音神煞·十神·用神/喜神", icon: "☯️" },
            { name: "紫微斗数", eng: "Zi Wei", desc: "十四主星十二宫·四化能量流·三方四正·身宫特判", icon: "⭐" },
            { name: "六爻起卦", eng: "Liu Yao", desc: "MD5 种子确定性算法·真实铜钱模拟·64卦动变化解", icon: "🪙" },
            { name: "奇门遁甲", eng: "Qi Men", desc: "ephem 节气精算·地天人神四盘·九宫八门九星八神", icon: "🧭" },
          ].map((e, i) => (
            <div key={i} style={{
              background: "rgba(255,255,255,.8)",
              border: "1px solid rgba(6,78,59,.08)",
              borderRadius: 10,
              padding: "14px 16px",
            }}>
              <div style={{ fontSize: 16, fontWeight: 600, color: TXT, marginBottom: 4 }}>
                {e.icon} {e.name} <span style={{ fontSize: 12, color: TXT2, fontWeight: 400 }}>{e.eng}</span>
              </div>
              <div style={{ fontSize: 12, color: TXT2, lineHeight: 1.6 }}>{e.desc}</div>
            </div>
          ))}
        </div>

        {/* Trust Section */}
        <h2 style={{
          fontSize: 20, fontWeight: 600, color: DG,
          marginBottom: 16, marginTop: 40,
          borderLeft: `3px solid ${GD}`, paddingLeft: 12,
        }}>
          ✅ 质量保证 — 1,127 项自动化测试
        </h2>
        <p style={{ fontSize: 15, lineHeight: 1.9, color: TXT2, marginBottom: 24 }}>
          每个引擎的计算结果都经由自动化测试验证：
          <br />· 金标准测试 55/55 — 经典案例精确匹配
          <br />· 深度金标准 13/13 — 复杂场景交叉验证
          <br />· 模糊测试 1000 次 · 0 Crash — 极端输入不崩溃
          <br />· 七引擎统计+不变式 33/33 — 数学正确性验证
        </p>

        {/* Creator */}
        <h2 style={{
          fontSize: 20, fontWeight: 600, color: DG,
          marginBottom: 16, marginTop: 40,
          borderLeft: `3px solid ${GD}`, paddingLeft: 12,
        }}>
          🙏 关于我们
        </h2>
        <p style={{ fontSize: 15, lineHeight: 1.9, color: TXT2, marginBottom: 24 }}>
          澄光命盘由 Jack Xu 创建。十余年命理研究经验，结合现代软件工程，打造出以数学引擎为核心、AI 叙事为辅助的能量洞察平台。<br /><br />
          Vajra Portal（如意宝金刚社群）是 LUMINA 的修行人社区，由加拿大注册非营利组织 BTFCANADA 运营，提供法会日历、上师教法、修行路径等服务。
        </p>

        {/* CTA */}
        <div style={{ textAlign: "center", marginTop: 48, marginBottom: 40 }}>
          <button
            onClick={() => navigate("/oracle")}
            style={{
              padding: "14px 40px",
              borderRadius: 10,
              background: `linear-gradient(135deg, ${DG}, ${GD})`,
              color: "#fff",
              fontSize: 16,
              fontWeight: 600,
              border: "none",
              cursor: "pointer",
              boxShadow: "0 4px 16px rgba(6,78,59,.25)",
            }}
          >
            🔮 免费体验四引擎问事
          </button>
        </div>
      </div>
    </div>
  );
}
